import { URI } from '@/config/config'

export default async ({ rootState }, payload) => {
  const url = new URL(`${URI}control-panel/employee`)

  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    }
  }

  if (payload) {
    url.search = new URLSearchParams(payload).toString()
  }

  const userLoginInfoResult = await fetch(url, opts)
  const jsonResult = await userLoginInfoResult.json()

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }
  
  return jsonResult.list
}